import request from "@/utils/request.js";

/**
 *手机验证码登录获取验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginPhoneSendCode(params) {
  return request({
    url: "/userService/api/app/user/nurse/login/loginPhoneSendCode",
    method: "post",
    data: params
  });
}
/**
 * 忘记密码重置密码发送验证码;
 * @param params
 * @returns {AxiosPromise}
 */
export function sendVerifyCode(params) {
  return request({
    url: "/userService/api/app/userNurse/forgetPasswordSendCode",
    method: "post",
    data: params
  });
}
